import React from 'react';
import Accordion from "../../../../../../../../components/blocks/Accordion";
import AccordionItem from "../../../../../../../../components/blocks/Accordion/AccordionItem";
import AttachmentCard from "../../../../../../../../components/blocks/AttachmentCard";
import {CourseOrderLocalItemResult} from "../../../../../../../../services/courseOrder/models/CourseOrderType";
import {useTranslation} from "react-i18next";


function Index({ order }: { order: CourseOrderLocalItemResult | null }) {
    const { t } = useTranslation("Orders");
    if ((!order?.selectedCourseOrderReferees ||
        order?.selectedCourseOrderReferees?.length==0)
    ) return <></>; // Return empty fragment if order is null or isbn is not present
    return (
        <Accordion>
            <AccordionItem initiallyOpen title={t("RefereeRecommendations")} elementId={"RefereeRecommendations"}>

                {order?.selectedCourseOrderReferees.map((referee,index) => {

                    return <>
                        <div className={"d-flex align-items-center gap-4 flex-wrap"}>
                            <div className={"fw-bold fs-6"}> {t("referee")} {index+1}:</div>
                            <div className={"d-flex flex-column flex-1 gap-2 border-1 " }>
                                {referee.showRecommendation && 
                                    referee.courseOrderReferee?.refereeEvaluationFormValue?.criteriaValues?.filter(w=>w.isShowable&& (w.notes!='' && w.notes))?.length>0 
                                    && (<div className={"fw-bold"}> {t("CriteriaRecommendation")}:</div>)}
                                {referee.showRecommendation &&
                                    referee.courseOrderReferee?.refereeEvaluationFormValue?.criteriaValues?.filter(w=>w.isShowable&& (w.notes!='' && w.notes))?.length>0
                                     && (<div className={"d-flex flex-column gap-2 my-2 "}>

                                        {referee.courseOrderReferee?.refereeEvaluationFormValue?.criteriaValues?.filter(w=>w.isShowable&& (w.notes!='' && w.notes)).map((criteria ,index)=>(
                                            <div className={"d-flex gap-2"}>
                                                <div className={"fw-bold"}> {index+1} -</div>
                                                <div> {criteria?.notes|| ''}</div>
                                            </div>
                                        ))}
                                        </div>)}
                                
                                {referee.showFiles && (<div className={"fw-bold"}> {t("Files")}:</div>)}
                                {referee.showFiles && (
                                    <div className="d-flex gap-3 mt-2 ">
                                        {referee?.courseOrderReferee?.refereeEvaluationFormValue?.files?.length ? (
                                            referee?.courseOrderReferee?.refereeEvaluationFormValue?.files?.map((attachment) => (
                                                <AttachmentCard
                                                    key={attachment.id}
                                                    attachment={{
                                                        id: attachment.id,
                                                        fileName: attachment.name ?? "",
                                                        size: attachment.size ?? "",
                                                        extension: attachment.extension ?? "",
                                                    }}
                                                />
                                            ))
                                        ) : (
                                            <span>{t("Common:noData")}</span>
                                        )}
                                    </div>)}
                            </div>
                        </div>

                    </>
                }) }

                <div className="divider mt-4 "></div>
            </AccordionItem>
        </Accordion>
    );
}

export default Index;